<template>
    <v-flex xs12>
        <v-card text color="grey lighten-4">
            <v-card-text>
                <v-flex xs12 md6>
                    <v-text-field
                            name="audience"
                            label="Name your audience"
                            prepend-icon="label"
                            @input="setName"
                            :value="name"
                    ></v-text-field>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
  export default {
    name: 'step-one',
    data () {
      return {}
    },
    props: ['name'],
    methods: {
      setName (val) {
        this.$emit('setName', val)
      }
    }
  }
</script>
